import { AbstractControl, FormGroup } from '@angular/forms';

export class AtLeastOneValidator {
	static atLeastOne(controlGroup: FormGroup) {
		let controls = controlGroup.controls;
		if (controls) {
			let theOne = Object.keys(controls).find(key => controls[key].value);
			if (!theOne) {
				return {
					atLeastOne: {
						text: 'Al menos un campo debe ser llenado'
					}
				};
			}
		}
		return null;
	}

	static nameCompleted(control: AbstractControl) {

		const nombre = control.get('nombre').value;
		const apellido = control.get('apellido').value;

		if ((nombre != null && nombre != '') && (apellido == null || apellido == '')) {
			return {
				nameCompleted: {
					text: 'Debe completar el apellido'
				}
			};
		} else if ((nombre == null || nombre == '') && (apellido != null && apellido != '')) {
			return {
				nameCompleted: {
					text: 'Debe completar el nombre'
				}
			};
		}
		return null;
	}

}
